// extracted by mini-css-extract-plugin
export var blockedMessage = "_bc-3";
export var blockedOverlay = "_bc-1";
export var fadeIn = "_bc-2";
export var hereLink = "_bc-0";
export var slideUp = "_bc-4";